$shm_hitalama_map_widget_view_autoview $mol_view
	code_widget $shm_hitalama_map_widget
	Map_page $shm_hitalama_map_page
	sub /
		^ autoview_content /
			<= Run $mol_button_major
				sub /
					<= Run_icon $mol_icon_play
				click? <=> run_click? null
			<= Table $mol_grid
				minimal_height 0
				records <= table_rows *
				col_ids <= table_col_ids /
				col_head_content* <= table_col_head_content* /
			<= Dom_wrapper null
	Dump $mol_dump_value
		value <= result null
		style *
			^
			--shm_hitalama_map_widget_float_autoview_font_size <= font_size_px \16px
